
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import timePeriodMixins from '~/mixins/timePeriodMixins';
import blogMixins from '~/mixins/blogMixins';

export default {
  name: 'ImageBannerAd',
  mixins: [eventTrackingMixins, timePeriodMixins, blogMixins],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    position: {
      type: String,
      default: '',
    },
    positionIndex: {
      type: Number,
      default: 0, // dynamic zone with dynamic index, static for others
    }
  },
  data() {
    return {
      trackingName: 'banner',
      bannerLinks: [], // store generated links
    }
  },
  mounted() {
    // Only runs on client, safe to use window/document
    this.bannerLinks = this.validItems.map(item => this.generateBannerLink(item));
  },
  watch: {
    validItems: {
      handler(newItems) {
        // Update links if validItems change
        this.bannerLinks = newItems.map(item => this.generateBannerLink(item));
      },
    }
  },
  computed: {
    validItems() {
      // check items in Image Banner Ad and Image Banner Ad List are valid
      return this.data?.filter(item =>
        item?.publishedAt !== null &&
        item?.image_banner_ad?.publishedAt !== null &&
        item?.c_page_ad_position?.filter?.position_code === this.position &&
        (
          (item?.start_date_time !== null || item?.end_date_time !== null)
        ? this.isActivePeriod({
            StartDateTime: item?.start_date_time,
            EndDateTime: item?.end_date_time
          })
        : true
        )
      )
    },
    getPositionIndex() {
      return this.positionIndex !== 0 ? this.positionIndex : '';
    },
  },
  methods: {
    generateBannerLink(item) {
      // if (process.client) {
        return item?.image_banner_ad?.BlogWhatsappMsg ? this.generateWhatsappMsgLink(item?.image_banner_ad?.BlogWhatsappMsg, item?.image_banner_ad?.Link) : item?.image_banner_ad?.Link;
      // } else {
      //   return item?.image_banner_ad?.Link;
      // }
    },
    getPositionCode(item) {
      return item?.c_page_ad_position?.filter?.position_code + this.getPositionIndex;
    },
    handleClick(eventTarget, item, position) {
      this.handleTrackingClick(eventTarget, this.trackingName, item, { position });
    },
  }
}
